module.exports = __webpack_public_path__ + "img/1.7a055fac.jpg";